import React, { useState, useEffect, useRef } from "react";
import RichText from "utils/RichText";
import Heading from "utils/Heading";
import Button from "utils/Button";
import { Disclosure } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Section = (props) => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <Disclosure as="div" className="py-10 last:border-b">
      {({ open }) => (
        <>
          <dt>
            <Heading size="h2" className="!text-6xl lg:!mb-6 lg:!text-[146px]">
              {props.title}
            </Heading>
            <Disclosure.Button className="group flex w-full items-start justify-between text-left">
              <Button icon={open ? "minus" : "plus"}>
                {props.button_title}
              </Button>
            </Disclosure.Button>
          </dt>
          <dd className="pr-12">
            <div
              style={{ maxHeight: open ? height : 0 }}
              className={classNames(
                open ? "mb-0" : "mb-0",
                "transform overflow-hidden transition-all duration-500 ease-in-out"
              )}
            >
              <div className="max-w-4xl text-lg lg:text-lg " ref={ref}>
                <RichText>{props.content}</RichText>
              </div>
            </div>
          </dd>
        </>
      )}
    </Disclosure>
  );
};

const ShowAndHide = ({ blok }) => {
  return (
    <div className="relative my-12 sm:my-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Heading size="h2" className="lg!:text-[44px]">
          {blok.title}
        </Heading>
        <span className="prose-indigo mt-4 text-lg lg:text-2xl">
          <RichText>{blok.content}</RichText>
        </span>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <dl
          v-for="item in items"
          className="mt-1 space-y-1 divide-y divide-[#091DF3] border-[#091DF3] last:border-b last:pb-1"
        >
          {blok.items &&
            blok.items.map((item) => (
              <Section {...item} key={item.title}></Section>
            ))}
        </dl>
      </div>
    </div>
  );
};

export default ShowAndHide;
